export default __webpack_public_path__ + "static/media/White-ArrowTop.c5743382.svg";